import CustomModal from "../CustomModal";

const PaymentDeclineModal = ({
  isOpen,
  onRequestClose,
  paymentDetails,
  onDecline,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-admin-modal decline"
      contentLabel="Notification Decline"
    >
      <div className="add-staff-head">
        <h2>Payment Overview</h2>
      </div>
      <img
        src={`${process.env.PUBLIC_URL}/images/decline-payment.png`}
        alt="decline payment"
      />
      <p style={{ textAlign: "center", fontWeight: "bold" }}>
        Are you sure you want to decline this payment?
      </p>
      {paymentDetails && (
        <div className="details-container container">
          <div className="detail">
            <p>Payer's name</p>
            <b>
              <p className="D">{paymentDetails.payer_name}</p>
            </b>
          </div>
          <div className="detail">
            <p>Gym Number</p>
            <b>
              <p className="D">{paymentDetails.user_id}</p>
            </b>
          </div>
          <div className="detail">
            <p>Payment Method</p>
            <b>
              <p className="D">{paymentDetails.payment_method}</p>
            </b>
          </div>
          <div className="detail">
            <p>Date of Payment</p>
            <b>
              <p className="D">{paymentDetails.date}</p>
            </b>
          </div>
          <div className="detail">
            <p>Amount Paid</p>
            <b>
              <p className="D">₦{paymentDetails.amount}</p>
            </b>
          </div>
        </div>
      )}
      <div className="modal-button">
        <button type="button" onClick={onRequestClose}>
          Back
        </button>
        <button
          type="button"
          onClick={onDecline}
          style={{ backgroundColor: "red", color: "white" }}
        >
          Decline
        </button>
      </div>
    </CustomModal>
  );
};

export default PaymentDeclineModal;
